import type { IGetStrategyLevelInfoResponse } from '@/Module/Grade/Model/ApiModel';
import type { IStrategyLevel } from '@/Module/Grade/Model/DataModel';

export const prepareStrategyLevelList = (rawData: IGetStrategyLevelInfoResponse[]): IStrategyLevel[] => {
  if (!rawData || rawData.length === 0) {
    return [];
  }

  const menuList: IStrategyLevel[] = [
    { id: 150, name: 'درس‌ها', seo_url_slug: '', child: [] },
    { id: 200, name: 'آمادگی آزمون', seo_url_slug: '', child: [] },
  ];

  const findOrCreate = (list: IStrategyLevel[], id: number, name: string): IStrategyLevel => {
    let item = list.find(child => child.id === id);
    if (!item) {
      item = { id, name, child: [] };
      list.push(item);
    }
    return item;
  };

  rawData.forEach(item => {
    const { strategy_type: strategyType, seo_info: seoInfo } = item;
    const level = item.education_level?.level;
    const grade = item.education_level?.grade;
    const field = item.education_level?.field;

    if (strategyType?.id === 1) {
      const subjectMenu = findOrCreate(menuList[0].child!, Number(level?.id), String(level?.name));
      const gradeItem = findOrCreate(subjectMenu.child!, Number(grade?.id), String(grade?.name));

      if (field?.id === 1) {
        gradeItem.seo_url_slug = seoInfo?.seo_url_slug;
      } else {
        const fieldItem = findOrCreate(gradeItem.child!, Number(field?.id), String(field?.name));
        fieldItem.seo_url_slug = seoInfo?.seo_url_slug;
      }
    } else if (strategyType?.id === 5) {
      const examMenu = findOrCreate(menuList[1].child!, Number(strategyType?.id), String(strategyType?.title));
      const fieldItem = findOrCreate(examMenu.child!, Number(field?.id), String(field?.name));
      const gradeItem = findOrCreate(fieldItem.child!, Number(grade?.id), String(grade?.name));
      gradeItem.seo_url_slug = seoInfo?.seo_url_slug;
    } else {
      const examMenu = findOrCreate(menuList[1].child!, Number(strategyType?.id), String(strategyType?.title));
      const levelItem = findOrCreate(examMenu.child!, Number(grade?.id), String(grade?.name));

      if (field?.id === 1) {
        levelItem.seo_url_slug = seoInfo?.seo_url_slug;
      } else {
        const fieldItem = findOrCreate(levelItem.child!, Number(field?.id), String(field?.name));
        fieldItem.seo_url_slug = seoInfo?.seo_url_slug;
      }
    }
  });

  const cleanEmptyChildren = (list: IStrategyLevel[]): IStrategyLevel[] => {
    return list.map(({ child, ...rest }) => ({
      ...rest,
      ...(child && child.length > 0 ? { child: cleanEmptyChildren(child) } : {}),
    }));
  };

  return cleanEmptyChildren(menuList);
};
